const pad = (value: number) => value.toString().padStart(2, '0');

/**
 * Convert a time string ("HH:MM" or "HH:MM:SS") to minutes since midnight.
 */
export const parseTimeToMinutes = (timeString?: string | null): number | null => {
  if (!timeString) return null;
  const parts = timeString.split(':').map((segment) => parseInt(segment, 10));
  if (parts.some((part) => Number.isNaN(part))) {
    return null;
  }
  const [hours = 0, minutes = 0] = parts;
  return hours * 60 + minutes;
};

/**
 * Format minutes since midnight back into HH:MM.
 */
export const formatMinutesToTime = (minutes?: number | null): string => {
  if (minutes === null || minutes === undefined || Number.isNaN(minutes)) {
    return 'N/A';
  }
  const normalized = Math.max(0, minutes);
  const hours = Math.floor(normalized / 60);
  const mins = normalized % 60;
  return `${pad(hours)}:${pad(mins)}`;
};

/**
 * Calculate variance (actual - scheduled) in minutes.
 */
export const getCallTimeVarianceMinutes = (
  scheduled?: string | null,
  actual?: string | null
): number | null => {
  const scheduledMinutes = parseTimeToMinutes(scheduled);
  const actualMinutes = parseTimeToMinutes(actual);
  if (scheduledMinutes === null || actualMinutes === null) {
    return null;
  }
  return actualMinutes - scheduledMinutes;
};

/**
 * Format a variance into a human-friendly label.
 */
export const formatVarianceLabel = (varianceMinutes?: number | null): string => {
  if (varianceMinutes === null || varianceMinutes === undefined) {
    return 'Not reported';
  }

  if (varianceMinutes === 0) {
    return 'On time';
  }

  const direction = varianceMinutes > 0 ? 'late' : 'early';
  const absolute = Math.abs(varianceMinutes);
  const hours = Math.floor(absolute / 60);
  const minutes = absolute % 60;

  const parts: string[] = [];
  if (hours > 0) {
    parts.push(`${hours}h`);
  }
  if (minutes > 0 || hours === 0) {
    parts.push(`${minutes.toString().padStart(2, '0')}m`);
  }
  return `${parts.join(' ')} ${direction}`;
};

